"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransferExtraProcessor = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _chains = require("@blockwell/chains");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
class TransferExtraProcessor {
  constructor() {
    (0, _defineProperty2.default)(this, "key", "transfers");
  }
  async process(parameters, submission) {
    let transfers = [];
    for (let step of submission.data.steps) {
      if (step.events) {
        for (let event of step.events) {
          var _event$topics;
          if ((event === null || event === void 0 ? void 0 : (_event$topics = event.topics) === null || _event$topics === void 0 ? void 0 : _event$topics[0]) === "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef") {
            let transfer = {
              address: event.address,
              chainId: (0, _chains.getChain)(step.network).chainId,
              from: "0x" + event.topics[1].slice(-40),
              to: "0x" + event.topics[2].slice(-40)
            };
            let contract = await parameters.contracts.getContract(transfer);
            if (contract) {
              var _contract$parameters;
              transfer.name = contract.name;
              transfer.symbol = (_contract$parameters = contract.parameters) === null || _contract$parameters === void 0 ? void 0 : _contract$parameters.symbol;
            }
            if (event.topics.length === 4) {
              transfers.push({
                ...transfer,
                type: "erc721",
                tokenId: new _bignumber.default(event.topics[3]).toString(10)
              });
            } else {
              var _contract$parameters2;
              let value = new _bignumber.default(event.data);
              transfers.push({
                ...transfer,
                type: "erc20",
                value: value.toString(10),
                amount: value.div(`1e${((_contract$parameters2 = contract.parameters) === null || _contract$parameters2 === void 0 ? void 0 : _contract$parameters2.decimals) || 18}`).toString(10)
              });
            }
          }
        }
      }
    }
    return transfers;
  }
}
exports.TransferExtraProcessor = TransferExtraProcessor;
//# sourceMappingURL=TransferExtra.js.map